import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ImportJobsTable, ImportUploadForm } from "./components/EligibilityImportViews";
import { PATIENT_IMPORT_JOB_TYPES, downloadImportTemplate, useImportJobs } from "./ImportJobs";

function EligibilityImportJobs() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [uploading, setUploading] = useState(false);
  const jobsList = useImportJobs({ enabled: true, type: PATIENT_IMPORT_JOB_TYPES.CHECK_ELIGIBILITY });

  const openJob = (jobId) => navigate(`/eligibility/import-jobs/${encodeURIComponent(jobId)}`);

  return (
    <div className="eligibility_container">
      <div className="flex items-center gap-1 mb-2">
        <IconButton size="small" aria-label={t("Back")} onClick={() => navigate("/eligibility")} sx={{ color: "#2441c9" }}>
          <ArrowBackIcon fontSize="small" />
        </IconButton>
        <span className="font-semibold text-black/70 text-lg">{t("Bulk Eligibility Check")}</span>
      </div>

      <ImportUploadForm
        jobType={PATIENT_IMPORT_JOB_TYPES.CHECK_ELIGIBILITY}
        uploadHint={t(
          "Upload an .xlsx workbook containing eligibility records. Processing continues in the background after the file is saved, even if you close this window.",
        )}
        onDownloadSample={() => downloadImportTemplate("eligibility.xlsx")}
        onBusyChange={setUploading}
        onUploaded={(jobId) => {
          jobsList.refresh();
          openJob(jobId);
        }}
      />

      <div className="mt-3">
        <ImportJobsTable
          jobs={jobsList.jobs}
          loading={jobsList.loading}
          error={jobsList.error}
          page={jobsList.page}
          totalPages={jobsList.totalPages}
          onPageChange={jobsList.setPage}
          onView={(row) => openJob(row.job_id)}
          onRefresh={jobsList.refresh}
          disabled={uploading}
        />
      </div>
    </div>
  );
}

export default EligibilityImportJobs;
